import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { dynamicDataAttribute } from 'helpers/utils'
import kebabCase from 'lodash/kebabCase'
import withType from 'components/common/hoc/withType'
import Button from 'components/common/Button/Button'
import Theme from 'components/common/Theme/Theme'
import { showRecoveryModal } from '../actions'

const AccountCredentialRecoveryLinks = ({
  links = [],
  showRecoveryModal
}) =>
  <RecoveryLinks data-at-loginform-recoverylinks>
    { links.map(({
      displayName = '',
      link: {
        path = ''
      } = {}
    }, index) =>
      <RecoveryModalButton
        link
        key={ index }
        { ...dynamicDataAttribute(kebabCase(displayName)) }
        onClick={ () => showRecoveryModal(path) } >
        { displayName }
      </RecoveryModalButton>)
    }
  </RecoveryLinks>

AccountCredentialRecoveryLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape()),
  showRecoveryModal: PropTypes.func
}

export default compose(
  withType({ type: 'AccountCredentialRecoveryLinks', placeholders: ['links']}),
  connect(null, { showRecoveryModal })
)(AccountCredentialRecoveryLinks)

const RecoveryLinks = styled.div`
  text-align: center;
  margin: 30px 0;

  & ${Button} {
    font-weight: 600;

    &:first-child::after {
      display: inline-block;
      width: 1px;
      height: 14px;
      margin: 0 10px;
      line-height: 47px;
      vertical-align: middle;
      background: ${Theme.colors.light_grey};
      content: '';
    }
  }
`

const RecoveryModalButton = styled(Button)`
  :hover {
    text-decoration: underline;
  }

  && {
    padding: 0;
    margin-left: 0;
    letter-spacing: normal;
  }
`
